import { render, staticRenderFns } from "./home-place-card.vue?vue&type=template&id=fd0580ba&scoped=true&"
import script from "./home-place-card.vue?vue&type=script&lang=js&"
export * from "./home-place-card.vue?vue&type=script&lang=js&"
import style0 from "./home-place-card.vue?vue&type=style&index=0&id=fd0580ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0580ba",
  null
  
)

export default component.exports